import {Paper, Stack, Text, Title} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

export default function MigrationPreviewSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: React.ReactNode;
}): JSX.Element {
  return (
    <Paper withBorder={true} p="md" radius="md">
      <Stack spacing="sm">
        <Title order={5} {...getTestProps({component: 'MigrationPreviewSection', element: 'title'})}>
          {title}
        </Title>
        {description != null && (
          <Text
            size="sm"
            color="dimmed"
            {...getTestProps({component: 'MigrationPreviewSection', element: 'description'})}
          >
            {description}
          </Text>
        )}
        {children != null && (
          <div {...getTestProps({component: 'MigrationPreviewSection', element: 'content'})}>{children}</div>
        )}
      </Stack>
    </Paper>
  );
}
